module.exports = __webpack_public_path__ + "427a7233a2bbd6d8596b20e1f8760861.MP3";